<template>
  <div>
    <hr />

    <!-- Filtros -->
    <div class="container mb-3">
      <div class="row g-2 align-items-end">
        <!-- Descripción -->
<!--
        <div class="col-auto">
          <label class="form-label fw-bold">Descripción</label>
          <input
            type="text"
            class="form-control"
            v-model="descripcionBusqueda"
            @keyup.enter="getDataDescripcion(1)"
            style="width:130px; text-transform:uppercase"
          />
        </div>
-->
        <!-- Clasificación -->
        <div class="col-auto">
          <label class="form-label fw-bold">Clasificación</label>
          <select
            v-model="clasificacionBusqueda"
            class="form-select"
            style="width:150px"
            @change="getDataClasificacion(1)"
          >
            <option value="" disabled selected>Seleccione...</option>
            <option value="2">TPSNS</option>
            <option value="10">Medicamentos</option>
            <option value="11">Insumos</option>
          </select>
        </div>
        <!-- Código TPSNS -->
        <div class="col-auto">
          <label class="form-label fw-bold">Código TPSNS</label>
          <input
            type="text"
            class="form-control"
            v-model="codigoBusqueda"
            @keyup.enter="getDataCodigo(1)"
            style="width:160px; text-transform:uppercase"
          />
        </div>
        <!-- Elemento TPSNS -->
        <div class="col-auto">
          <label class="form-label fw-bold">Elemento TPSNS</label>
          <input
            type="text"
            class="form-control"
            v-model="nombreBusqueda"
            @keyup.enter="getDataNombre(1)"
            style="width:280px; text-transform:uppercase"
          />
        </div>
        <!-- Acciones -->
        <div class="col-auto d-flex gap-2">
          <button
            type="button"
            class="btn btn-outline-primary"
            @click.prevent="getDataPaginaTodos(1)"
            title="Todos los registros"
          >
            <i class="material-icons" style="font-size:24px">auto_awesome_motion</i>
          </button>
          <button
            v-if="auditoriaMedica"
            type="button"
            class="btn btn-outline-success"
            @click="abrirModalCrear"
            title="Nuevo registro"
          >
            <i class="material-icons" style="font-size:24px">add_box</i>
          </button>
          <button
            v-if="auditoriaMedica"
            type="button"
            class="btn btn-outline-secondary"
            @click="exportToCSV"
            title="Exportar CSV"
          >
            <i class="material-icons me-1" style="font-size:16px;vertical-align:middle">download</i>CSV
          </button>
          <button
            v-if="auditoriaMedica"
            type="button"
            class="btn btn-outline-secondary"
            @click="exportToExcel"
            title="Exportar Excel"
          >
            <i class="material-icons me-1" style="font-size:16px;vertical-align:middle">download</i>XLSX
          </button>
        </div>
      </div>
    </div>

    <!-- Selector registros por página -->
    <div class="d-flex justify-content-end align-items-center gap-2 mb-2">
      <label class="form-label mb-0 small fw-bold">Mostrar</label>
      <select
        v-model="elementosPorPagina"
        class="form-select form-select-sm"
        style="width:90px"
        @change="updateItemsPerPage"
      >
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="100">100</option>
        <option value="100000000">Todos</option>
      </select>
      <span class="small text-muted">registros</span>
    </div>

    <!-- Tabla -->
    <div class="table-responsive">
      <table class="table table-hover table-bordered table-sm" id="sampleTable">
        <thead class="table-dark">
          <tr>
            <th class="text-center"></th>
            <th class="th-sort" @click="ordenarPor('fechaAtencion')">
              Fecha <span>{{ iconOrden('fechaAtencion') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('elementoCodigo')">
              Código TPSNS <span>{{ iconOrden('elementoCodigo') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('elementoNombre')">
              Elemento TPSNS <span>{{ iconOrden('elementoNombre') }}</span>
            </th>
            <th class="th-sort text-end" @click="ordenarPor('cantidad')">
              Cantidad <span>{{ iconOrden('cantidad') }}</span>
            </th>
            <th class="th-sort text-end" @click="ordenarPor('valorUni')">
              V. Unitario <span>{{ iconOrden('valorUni') }}</span>
            </th>
            <th class="th-sort text-end" @click="ordenarPor('valorTotal')">
              V. Total <span>{{ iconOrden('valorTotal') }}</span>
            </th>
            <th v-if="auditoriaMedica" class="text-end">Lab.</th>
            <th v-if="auditoriaMedica" class="text-end">Img.</th>
            <th v-if="auditoriaMedica"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="planilladet in datosPaginados"
            :key="planilladet.idPlanillaDet"
            @dblclick="handleRowClick($event, planilladet.idPlanillaDet)"
            :class="{ 'table-warning': planilladet.revisado == 1 }"
          >
            <td class="text-center">
              <span
                class="material-symbols-outlined"
                style="font-size:24px; color:green; cursor:pointer"
                role="button"
                @click.prevent="actualizarRevision(planilladet, planilladet.revisado)"
                title="Marcar como revisado"
              >
                {{ planilladet.revisado == 1 ? 'check_box' : 'check_box_outline_blank' }}
              </span>
            </td>
            <td>{{ getFormattedDate(planilladet.fechaAtencion) }}</td>
            <td>{{ planilladet.elementoCodigo }}</td>
            <td>{{ planilladet.elementoNombre }}</td>
            <td class="text-end">{{ planilladet.cantidad }}</td>
            <td class="text-end">{{ planilladet.valorUni }}</td>
            <td class="text-end">{{ planilladet.cantidad * planilladet.valorUni }}</td>
            <td v-if="auditoriaMedica" class="text-end">
              <span
                v-if="planilladet.laboratorio == 1"
                title="Actualizar fecha en elementos de laboratorios"
                style="cursor:pointer"
                @click="actualizarFechaLab(planilladet.idPlanilla, planilladet.idPlanilla, planilladet.fechaAtencion)"
              >
                <span class="material-symbols-outlined" style="font-size:24px; color:green">date_range</span>
              </span>
            </td>
            <td v-if="auditoriaMedica" class="text-end">
              <span
                v-if="planilladet.imagen == 1"
                class="btn btn-sm btn-outline-primary d-inline-flex align-items-center justify-content-center"
                title="Actualizar fecha en elementos de imagen"
                style="width:40px; height:40px; cursor:pointer"
                @click="actualizarFechaLab(planilladet.idPlanilla, planilladet.idPlanilla, planilladet.fechaAtencion)"
              >
                <span class="material-symbols-outlined" style="font-size:24px; color:white">date_range</span>
              </span>
            </td>
            <td>
              <select
                v-if="auditoriaMedica"
                class="form-select form-select-sm"
                @change="handleAction($event, planilladet.idPlanillaDet)"
              >
                <option disabled selected>Seleccione...</option>
                <option value="editar" v-if="p_estadoTramite === 'RECIBIDO'">Editar</option>
                <option value="observaciones">Observaciones</option>
                <option v-if="idPerfil == 16 || 1 == 1" value="borrar">Borrar</option>
              </select>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary fw-bold">
            <td colspan="4" class="text-end">Total:</td>
            <td class="text-end">{{ contarRegistros }}</td>
            <td></td>
            <td class="text-end">{{ calcularTotal }}</td>
            <td v-if="auditoriaMedica"></td>
            <td v-if="auditoriaMedica"></td>
            <td v-if="auditoriaMedica"></td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }} — {{ planilladets.length }} registros
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage()">‹</a>
          </li>
          <li
            v-for="pagina in paginasVisibles"
            :key="pagina"
            class="page-item"
            :class="{ active: pagina === paginaActual, disabled: pagina === '...' }"
          >
            <a class="page-link" href="#" @click.prevent="pagina !== '...' && fetchDataWithFilters(pagina)">
              {{ pagina }}
            </a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage()">›</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons text-white me-2">edit</span>
            <h5 class="modal-title text-white" id="exampleModalLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- Código -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Código</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPlanillaDet.codigo" disabled />
                  </div>
                </div>
              </div>
              <!-- Descripción -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Descripción</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPlanillaDet.descripcion" disabled />
                  </div>
                </div>
              </div>
              <!-- Código Estándar -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Código Estándar</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPlanillaDet.elementoCodigo" disabled />
                  </div>
                </div>
              </div>
              <!-- Descripción Estándar -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Descripción Estándar</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPlanillaDet.elementoNombre" disabled />
                  </div>
                </div>
              </div>
              <!-- Fecha / Cantidad / Valor -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Fecha de Atención</label></div>
                  <div class="col-2">
                    <input
                      type="date"
                      class="form-control"
                      v-model="datoPlanillaDet.fechaAtencion"
                      :min="getFormattedDateISO(p_fechaDesde)"
                      :max="getFormattedDateISO(p_fechaHasta)"
                    />
                  </div>
                  <div class="col-2"><label class="form-label">Cantidad</label></div>
                  <div class="col-2">
                    <input type="number" class="form-control" v-model="datoPlanillaDet.cantidad" required />
                  </div>
                  <div class="col-2"><label class="form-label">Valor unitario</label></div>
                  <div class="col-2">
                    <input type="number" class="form-control" v-model="datoPlanillaDet.valorUni" disabled />
                  </div>
                </div>
              </div>
              <hr />

              <!-- Bloque 1: Tabla de equivalencia -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Tabla de equivalencia</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoPlanillaDet.idElemento">
                      <option
                        v-for="elemento in elementosPrestador"
                        :value="elemento.idElemento"
                        :key="elemento.idElemento"
                      >
                        {{ elemento.elementoCodigo }} - {{ elemento.elementoNombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Bloque 2: Tarifario -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Elementos del tarifario</label></div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchTextTarifario"
                      @input="debouncedFilterTarifario"
                      placeholder="Buscar en tarifario..."
                    />
                  </div>
                </div>
              </div>
              <div v-if="filteredTarifario.length > 0" class="mb-3">
                <table class="table table-hover table-bordered table-sm">
                  <thead class="table-dark">
                    <tr>
                      <th>Código</th>
                      <th>Nombre</th>
                      <th class="text-end">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="tarifa in paginatedTarifario"
                      :key="tarifa.idTarifa"
                      @click="selectTarifario(tarifa)"
                      style="cursor:pointer"
                    >
                      <td>{{ tarifa.elementoCodigo }}</td>
                      <td>{{ tarifa.elementoNombre }}</td>
                      <td class="text-end">{{ tarifa.valor }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-between align-items-center mt-2">
                  <div class="d-flex gap-2">
                    <button type="button" class="btn btn-outline-primary btn-sm" :disabled="currentPageTarifario === 1" @click="currentPageTarifario--">Anterior</button>
                    <button type="button" class="btn btn-outline-primary btn-sm" :disabled="currentPageTarifario === totalPagesTarifario" @click="currentPageTarifario++">Siguiente</button>
                  </div>
                  <span class="small text-muted">Página {{ currentPageTarifario }} de {{ totalPagesTarifario }}</span>
                </div>
              </div>

              <!-- Bloque 3: Todos los elementos codificados -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Todos los elementos codificados</label></div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchTextElemento"
                      @input="debouncedFilterElementos"
                      placeholder="Buscar elemento..."
                    />
                  </div>
                </div>
              </div>
              <div v-if="filteredElementos.length > 0" class="mb-3">
                <table class="table table-hover table-bordered table-sm">
                  <thead class="table-dark">
                    <tr>
                      <th>Tipo</th>
                      <th>Código</th>
                      <th>Nombre</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="elemento in paginatedElementos"
                      :key="elemento.idElemento"
                      @click="selectElemento(elemento)"
                      style="cursor:pointer"
                    >
                      <td :style="{ backgroundColor: elemento.color }">{{ elemento.clasElemNombre }}</td>
                      <td>{{ elemento.codigo }}</td>
                      <td>{{ elemento.nombre }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-between align-items-center mt-2">
                  <div class="d-flex gap-2">
                    <button type="button" class="btn btn-outline-primary btn-sm" :disabled="currentPage === 1" @click="currentPage--">Anterior</button>
                    <button type="button" class="btn btn-outline-primary btn-sm" :disabled="currentPage === totalPages" @click="currentPage++">Siguiente</button>
                  </div>
                  <span class="small text-muted">Página {{ currentPage }} de {{ totalPages }}</span>
                </div>
              </div>

            </div>
          </form>
          <div class="modal-footer">
            <button
              v-if="btnCrear"
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarPlanillaDet"
              title="Guardar"
            >
              <i class="material-icons me-1" style="font-size:20px;vertical-align:middle">save</i>
              Guardar
            </button>
            <button
              v-if="btnEditar && p_procesoAM"
              type="button"
              class="btn btn-primary"
              @click.prevent="actualizarPlanillaDet"
              title="Actualizar"
            >
              <i class="material-icons me-1" style="font-size:20px;vertical-align:middle">update</i>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import * as bootstrap from "bootstrap";
import swal from "sweetalert";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

export default {
  props: {
    p_idTramite:     { type: Number,  required: true },
    p_idPrestador:   { type: Number,  required: true },
    p_estadoTramite: { type: String,  required: true },
    p_idPlanilla:    { type: Number,  required: true },
    p_numero:        { type: String,  required: true },
    p_fechaDesde:    { type: Date,    required: true },
    p_fechaHasta:    { type: Date,    required: true },
    p_tipo:          { type: String,  required: true },
    p_procesoAM:     { type: Boolean, required: true },
    p_tipoConsulta:  { type: String,  required: true },
  },
  data() {
    return {
      planilladets:           [],
      datoPlanillaDet:        {},
      nombreBusqueda:         "",
      descripcionBusqueda:    "",
      codigoBusqueda:         "",
      clasificacionBusqueda:  "",
      titulo:                 "",
      btnCrear:               false,
      btnEditar:              false,
      elementosPorPagina:     10,
      datosPaginados:         [],
      paginaActual:           1,
      modalWindow:            false,
      elementosPrestador:     [],
      elementos:              [],
      idPerfil:               0,
      idUsuario:              0,
      estiloImagen:           { width: "200px", height: "200px" },
      showDropdownElemento:   false,
      searchTextElemento:     "",
      filteredElementos:      [],
      debounceTimer:          null,
      currentPage:            1,
      itemsPerPage:           5,
      modalInstance:          null,
      // Ordenamiento
      campoOrden:             "fechaAtencion",
      ascendente:             false,
      // Tarifario
      searchTextTarifario:    "",
      filteredTarifario:      [],
      currentPageTarifario:   1,
      itemsPerPageTarifario:  5,
      debounceTimerTarifario: null,
    };
  },
  computed: {
    auditoriaMedica() {
      return (
        (this.idPerfil == 16 || this.idPerfil == 17 || this.idPerfil == 18) &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    supervisorGD() {
      return (
        this.idPerfil == 19 &&
        (this.p_estadoTramite === "RECIBIDO" ||
          this.p_estadoTramite === "EN PROCESO" ||
          this.p_estadoTramite === "PLANILLAJE")
      );
    },
    contarRegistros() {
      return this.planilladets.length;
    },
    calcularTotal() {
      return this.planilladets
        .reduce((total, p) => total + p.cantidad * p.valorUni, 0)
        .toFixed(2);
    },
    paginatedElementos() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredElementos.slice(start, start + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.filteredElementos.length / this.itemsPerPage);
    },
    paginatedTarifario() {
      const start = (this.currentPageTarifario - 1) * this.itemsPerPageTarifario;
      return this.filteredTarifario.slice(start, start + this.itemsPerPageTarifario);
    },
    totalPagesTarifario() {
      return Math.ceil(this.filteredTarifario.length / this.itemsPerPageTarifario);
    },
    paginasVisibles() {
      const total  = this.totalPaginas();
      const actual = this.paginaActual;
      const delta  = 2;
      const rango  = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2)                        rango.unshift("...");
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push("...");
      const paginas = [1];
      rango.forEach((p) => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },
  },
  watch: {
    filteredElementos() { this.currentPage = 1; },
    filteredTarifario()  { this.currentPageTarifario = 1; },
  },
  mounted() {
    this.idPerfil  = window.sessionStorage.getItem("idPerfil");
    this.idUsuario = window.sessionStorage.getItem("idUsuario");
    const savedItemsPerPage = localStorage.getItem("elementosPorPagina");
    if (savedItemsPerPage) this.elementosPorPagina = Number(savedItemsPerPage);
    this.fetchDataWithFilters(this.paginaActual);
  },
  beforeUnmount() {
    const modalElement = document.getElementById("ventanaModal");
    if (modalElement) modalElement.removeEventListener("hidden.bs.modal", this.onModalHidden);
  },
  methods: {
    // ── Ordenamiento ───────────────────────────────────────
    ordenarPor(campo) {
      if (this.campoOrden === campo) {
        this.ascendente = !this.ascendente;
      } else {
        this.campoOrden = campo;
        this.ascendente = campo === "fechaAtencion" ? false : true;
      }
      this._setPaginacion(this.planilladets, 1);
    },
    iconOrden(campo) {
      if (this.campoOrden !== campo) return "⇅";
      return this.ascendente ? "↑" : "↓";
    },
    // ── Helpers ────────────────────────────────────────────
    getFormattedDate(date)    { return dateFormat.getFormattedDate(date); },
    getFormattedDateISO(date) { return dateFormat.getFormattedDateISO(date); },

    handleRowClick(event, idPlanillaDet) {
      if (event.target.tagName === "SELECT" || event.target.tagName === "OPTION") return;
      if (this.auditoriaMedica || this.supervisorGD) this.abrirModalEditar(idPlanillaDet);
    },
    handleAction(event, idPlanillaDet) {
      const action = event.target.value;
      if      (action === "editar")        this.abrirModalEditar(idPlanillaDet);
      else if (action === "observaciones") this.observaciones(idPlanillaDet, this.p_tipo);
      else if (action === "borrar")        this.deletePlanillaDet(idPlanillaDet);
      event.target.value = "Seleccione...";
    },
    ordenarPorFechaYElemento(arr, fechaCampo, codigoCampo) {
      return arr.sort((a, b) => {
        const fechaA = new Date(a[fechaCampo]);
        const fechaB = new Date(b[fechaCampo]);
        if (fechaA < fechaB) return 1;
        if (fechaA > fechaB) return -1;
        if (a[codigoCampo] < b[codigoCampo]) return -1;
        if (a[codigoCampo] > b[codigoCampo]) return 1;
        return 0;
      });
    },

    // ── Paginación ─────────────────────────────────────────
    totalPaginas() {
      if (this.elementosPorPagina >= 100000000) return 1;
      return Math.max(1, Math.ceil(this.planilladets.length / this.elementosPorPagina));
    },
    getPreviousPage() {
      if (this.elementosPorPagina >= 100000000) return;
      if (this.paginaActual > 1) { this.paginaActual--; this.fetchDataWithFilters(this.paginaActual); }
    },
    getNextPage() {
      if (this.elementosPorPagina >= 100000000) return;
      if (this.paginaActual < this.totalPaginas()) { this.paginaActual++; this.fetchDataWithFilters(this.paginaActual); }
    },
    isActive(noPagina) { return noPagina === this.paginaActual ? "active" : ""; },
    updateItemsPerPage() {
      this.elementosPorPagina = Number(this.elementosPorPagina);
      this.paginaActual = 1;
      this.getDataPaginaTodos(1);
    },

    // ── Fetch con filtros ──────────────────────────────────
    fetchDataWithFilters(noPagina) {
      this.paginaActual = noPagina;
/*	  if      (this.descripcionBusqueda)   this.getDataDescripcion(noPagina); else */
      if (this.nombreBusqueda)        this.getDataNombre(noPagina);
      else if (this.codigoBusqueda)        this.getDataCodigo(noPagina);
      else if (this.clasificacionBusqueda) this.getDataClasificacion(noPagina);
      else                                 this.getDataPaginaTodos(noPagina);
    },
    _setPaginacion(data, noPagina) {
      const campo = this.campoOrden;
      const sorted = this.ordenarPorFechaYElemento([...data], "fechaAtencion", "elementoCodigo");
      // Aplicar ordenamiento personalizado si el campo no es el default
      if (campo !== "fechaAtencion") {
        sorted.sort((a, b) => {
          let va = a[campo] ?? "";
          let vb = b[campo] ?? "";
          if (campo === "cantidad" || campo === "valorUni" || campo === "valorTotal") {
            const na = campo === "valorTotal" ? a.cantidad * a.valorUni : parseFloat(va);
            const nb = campo === "valorTotal" ? b.cantidad * b.valorUni : parseFloat(vb);
            if (!isNaN(na) && !isNaN(nb)) return this.ascendente ? na - nb : nb - na;
          }
          const cmp = String(va).localeCompare(String(vb), "es");
          return this.ascendente ? cmp : -cmp;
        });
      }
      this.planilladets  = sorted;
      this.paginaActual  = noPagina;
      this.datosPaginados = [];
      if (this.elementosPorPagina >= 100000000) {
        this.datosPaginados = this.planilladets;
      } else {
        const ini = (noPagina - 1) * this.elementosPorPagina;
        this.datosPaginados = this.planilladets.slice(ini, ini + Number(this.elementosPorPagina));
      }
    },
/*	
    getDataDescripcion(noPagina) {
      if (!this.descripcionBusqueda) return;
      api.get(`/vwplanilladets/idplanilla-descripcion/${this.p_idPlanilla}/${this.descripcionBusqueda}`)
        .then((r) => this._setPaginacion(r.data, noPagina));
    },
*/	
    getDataNombre(noPagina) {
      if (!this.nombreBusqueda) return;
      api.get(`/vwplanilladets/idplanilla-elementonombre/${this.p_idPlanilla}/${this.nombreBusqueda}`)
        .then((r) => this._setPaginacion(r.data, noPagina));
    },
    getDataCodigo(noPagina) {
      if (!this.codigoBusqueda) return;
      api.get(`/vwplanilladets/idplanilla-codigo/${this.p_idPlanilla}/${this.codigoBusqueda}`)
        .then((r) => this._setPaginacion(r.data, noPagina));
    },
    getDataClasificacion(noPagina) {
      if (!this.clasificacionBusqueda) return;
      api.get(`/vwplanilladets/idplanilla-clasificacion/${this.p_idPlanilla}/${this.clasificacionBusqueda}`)
        .then((r) => this._setPaginacion(r.data, noPagina));
    },
    getDataPaginaTodos(noPagina) {
      this.descripcionBusqueda   = "";
      this.nombreBusqueda        = "";
      this.codigoBusqueda        = "";
      this.clasificacionBusqueda = "";
      api.get(`/vwplanilladets/idplanilla-estado/${this.p_idPlanilla}/1`)
        .then((r) => this._setPaginacion(r.data, noPagina));
    },

    // ── Validación ─────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoPlanillaDet,
        ["idElemento", "cantidad"],
        ["Elemento", "cantidad"]
      );
    },

    // ── CRUD ───────────────────────────────────────────────
    async guardarPlanillaDet() {
      if (this.validarForm() !== 1) return;
      try {
        if (this.datoPlanillaDet.cantidad <= 0) {
          swal("Error", "La cantidad no puede ser menor o igual que 0", "error");
          return;
        }
        this.datoPlanillaDet.idPlanilla   = this.p_idPlanilla;
        this.datoPlanillaDet.descripcion  = "Registrado por el equipo de planillaje";
        this.datoPlanillaDet.idUsuarioReg = this.idUsuario;
        const now = new Date();
        const offset = -5 * 60 * 60 * 1000;
        const localDate = new Date(now.getTime() + offset);
        this.datoPlanillaDet.fechaReg = localDate.toISOString().split(".")[0];
        await api.post("/planilladets", this.datoPlanillaDet);
        this.modalInstance.hide();
        this.modalWindow = false;
        swal("Correcto!", "Registro creado exitosamente!", "success");
        if (this.clasificacionBusqueda) this.getDataClasificacion(this.paginaActual);
        else                            this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        swal("Error!", "Inténtelo de nuevo!", "error");
      }
    },
    async actualizarPlanillaDet() {
      if (this.validarForm() !== 1) return;
      try {
        if (this.datoPlanillaDet.cantidad <= 0) {
          swal("Error", "La cantidad no puede ser menor o igual que 0", "error");
          return;
        }
        const now = new Date();
        const offset = -5 * 60 * 60 * 1000;
        const localDate = new Date(now.getTime() + offset);
        this.datoPlanillaDet.fechaAct     = localDate.toISOString().split(".")[0];
        this.datoPlanillaDet.revisado     = 1;
        this.datoPlanillaDet.idUsuarioAct = this.idUsuario;
        await api.post("/planilladets", this.datoPlanillaDet);
        this.modalInstance.hide();
        this.modalWindow = false;
        if (this.clasificacionBusqueda) this.getDataClasificacion(this.paginaActual);
        else                            this.getDataPaginaTodos(this.paginaActual);
        swal("Correcto!", "Registro actualizado exitosamente!", "success");
      } catch (error) {
        swal("Error!", "Inténtelo de nuevo!", "error");
        const array = Object.values(error.response?.data?.errors || {});
        array.forEach((element) => swal(String(element)));
      }
    },
    async deletePlanillaDet(idPlanillaDet) {
      try {
        await api.delete("/planilladets/" + idPlanillaDet);
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar. " + error);
      }
    },

    // ── Modales ────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow        = true;
      this.datoPlanillaDet    = {};
      this.titulo             = "Crear";
      this.btnCrear           = true;
      this.btnEditar          = false;
      this.searchTextElemento = "";
      this.$nextTick(() => {
        const modalElement = document.getElementById("ventanaModal");
        if (modalElement) {
          this.modalInstance = new bootstrap.Modal(modalElement, { backdrop: true });
          this.modalInstance.show();
          modalElement.addEventListener("hidden.bs.modal", this.onModalHidden);
        }
      });
    },
    async abrirModalEditar(idPlanillaDet) {
      this.modalWindow = true;
      if (idPlanillaDet != null) {
        await api.get("/vwplanilladets/" + idPlanillaDet).then((resp) => {
          this.datoPlanillaDet = resp.data;
        });
        await this.fetchElementosPrestador();
      }
      this.titulo    = "Editar";
      this.btnCrear  = false;
      this.btnEditar = true;
      if (this.datoPlanillaDet.fechaAtencion) {
        this.datoPlanillaDet.fechaAtencion = this.getFormattedDateISO(this.datoPlanillaDet.fechaAtencion);
      }
      this.$nextTick(() => {
        const modalElement = document.getElementById("ventanaModal");
        if (modalElement) {
          this.modalInstance = new bootstrap.Modal(modalElement, { backdrop: true });
          this.modalInstance.show();
          modalElement.addEventListener("hidden.bs.modal", this.onModalHidden);
        }
      });
    },
    onModalHidden() {
      this.modalWindow        = false;
      this.datoPlanillaDet    = {};
      this.titulo             = "";
      this.btnCrear           = false;
      this.btnEditar          = false;
      this.searchTextElemento = "";
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
      document.body.classList.remove("modal-open");
      document.body.style.paddingRight = "";
      if (this.modalInstance) { this.modalInstance.dispose(); this.modalInstance = null; }
    },

    // ── Fetch auxiliares ───────────────────────────────────
    async fetchElementosPrestador() {
      try {
        const url = `/vwelemequis/idprestador-elemPresCodigo/${this.p_idPrestador}/${this.datoPlanillaDet.codigo}`;
        const response = await api.get(url);
        this.elementosPrestador = response.data;
      } catch (error) {
        console.error("Error al obtener elementos prestador:", error);
      }
    },
    async fetchElementos() {
      try {
        if (this.searchTextElemento.length < 2) { this.filteredElementos = []; return; }
        const url = `/vwelementos/searchS3?search=${encodeURIComponent(this.searchTextElemento)}`;
        const response = await api.get(url);
        this.filteredElementos = response.data;
      } catch (error) {
        console.error("Error al obtener elementos:", error);
      }
    },
    debouncedFilterElementos() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.fetchElementos(), 300);
    },
    selectElemento(elemento) {
      this.datoPlanillaDet.idElemento     = elemento.idElemento;
      this.datoPlanillaDet.elementoNombre = elemento.nombre;
      this.datoPlanillaDet.elementoCodigo = elemento.codigo;
      this.searchTextElemento             = elemento.nombre;
      this.filteredElementos              = [];
      this.showDropdownElemento           = false;
    },
    hideDropdown() { this.showDropdownElemento = false; },
    showDropdown()  { this.showDropdownElemento = true;  },

    async fetchTarifario() {
      try {
        if (this.searchTextTarifario.length < 2) { this.filteredTarifario = []; return; }
        const url = `/vwtarifapress/search-prestador?idprestador=${this.p_idPrestador}&search=${encodeURIComponent(this.searchTextTarifario)}`;
        const response = await api.get(url);
        this.filteredTarifario = response.data;
      } catch (error) {
        console.error("Error al obtener tarifario:", error);
      }
    },
    debouncedFilterTarifario() {
      clearTimeout(this.debounceTimerTarifario);
      this.debounceTimerTarifario = setTimeout(() => this.fetchTarifario(), 300);
    },
    selectTarifario(tarifa) {
      this.datoPlanillaDet.idElemento     = tarifa.idElemento;
      this.datoPlanillaDet.elementoNombre = tarifa.elementoNombre;
      this.datoPlanillaDet.elementoCodigo = tarifa.elementoCodigo;
      this.datoPlanillaDet.valorUni       = tarifa.valor;
      this.searchTextTarifario            = tarifa.elementoNombre;
      this.filteredTarifario              = [];
    },

    // ── Acciones especiales ────────────────────────────────
    observaciones(idPlanillaDet) {
      if (idPlanillaDet != null) {
        sessionStorage.setItem("observacionesData", JSON.stringify({
          idTramite:     this.p_idTramite,
          estadoTramite: this.p_estadoTramite,
          idPlanillaDet: idPlanillaDet,
          tipo:          this.p_tipo,
          procesoAM:     this.p_procesoAM ? 1 : 0,
          tipoConsulta:  this.p_tipoConsulta,
        }));
        this.$router.push("/planilladet_pladetobs");
      }
    },
    async actualizarFechaLab(idPLanilla, idPLanillaDet, fechaAtencion) {
      try {
        await api.post(`/procedimientos/actualizar-fecha?idPlanilla=${idPLanilla}&idPlanillaDet=${idPLanillaDet}&fechaAtencion=${this.getFormattedDateISO(fechaAtencion)}`);
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        alert("No se pudo actualizar. " + error);
      }
    },
    async actualizarRevision(planilladet, revisadoValor) {
      try {
        const now = new Date();
        const offset = -5 * 60 * 60 * 1000;
        const localDate = new Date(now.getTime() + offset);
        const actualizado = {
          ...planilladet,
          revisado:     revisadoValor == 1 ? 0 : 1,
          fechaAct:     localDate.toISOString().split(".")[0],
          idUsuarioAct: this.idUsuario,
        };
        await api.post("/planilladets", actualizado);
        if (this.clasificacionBusqueda) this.getDataClasificacion(this.paginaActual);
        else                            this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        swal("Error!", "Inténtelo de nuevo!", "error");
        const array = Object.values(error.response?.data?.errors || {});
        array.forEach((element) => swal(String(element)));
      }
    },

    // ── Exportar ───────────────────────────────────────────
    exportToCSV() {
      if (this.planilladets.length === 0) {
        Swal.fire({ title: "Advertencia", text: "No hay datos para exportar.", icon: "warning", confirmButtonText: "OK" });
        return;
      }
      const headers = ["Fecha Atención", "Código", "Descripción", "Cantidad", "Valor Unitario", "Valor"];
      const csvContent = [
        "\uFEFF" + headers.join(";"),
        ...this.planilladets.map((row) =>
          [
            row.fechaAtencion || "",
            row.elementoCodigo || "",
            row.elementoNombre || "",
            row.cantidad || 0,
            row.valorUni || 0,
            (row.cantidad * row.valorUni) || 0,
          ]
            .map((value) => `"${value.toString().replace(/"/g, '""')}"`)
            .join(";")
        ),
      ].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url  = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `detalle_planilla_${this.p_idPlanilla}.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    exportToExcel() {
      if (this.planilladets.length === 0) {
        Swal.fire({ title: "Advertencia", text: "No hay datos para exportar.", icon: "warning", confirmButtonText: "OK" });
        return;
      }
      const headers = ["Fecha Atención", "Código", "Descripción", "Cantidad", "Valor Unitario", "Valor"];
      const data = this.planilladets.map((row) => [
        row.fechaAtencion,
        row.elementoCodigo,
        row.elementoNombre,
        row.cantidad,
        row.valorUni,
        row.cantidad * row.valorUni,
      ]);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Observaciones");
      XLSX.writeFile(wb, `detalle_planilla_${this.p_idPlanilla}.xlsx`);
    },
  },
};
</script>

<style scoped>
.dropdown-menu.show {
  display: block;
}
.button:hover {
  border-color: rgb(253, 209, 13);
  box-shadow: 0px 0px 10px 2px rgb(253, 209, 13);
  transform: translateY(-5px);
}
.table-hover tbody tr {
  cursor: pointer;
}
.table-hover tbody tr:hover {
  background-color: #f5f5f5;
}
#sampleTable tr.table-warning td {
  background-color: #fff3cd !important;
}
</style>	